import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/forge/Icon'

/**
 * The board's assistant rail.
 *
 * ── It lived in the anomaly Workboard tab, which no longer exists ────────
 * That tab was the design's investigation canvas scoped to one anomaly, and
 * every card on it was a literal — there is no board resource, so a board
 * reached from an anomaly could never be saved, shared or reopened. It was
 * removed; this component was its one part with a second caller, so it moved to
 * the module that still has a board to put it beside rather than being deleted
 * with the tab.
 *
 * It is still the Workboards module's demo rail: the prompts are keys, and
 * `onAsk` is a toast at both call sites. DEMO-MODE.md §8.2 carries the state of
 * that module.
 */
export function BoardAgent({ prompts, onAsk }) {
  const { t } = useTranslation(['app', 'common'])

  return (
    <aside className="flex w-full shrink-0 flex-col gap-3 rounded-sm border border-hairline bg-card p-4 xl:w-80">
      <div className="flex items-center gap-2">
        <Icon name="ai" size="sm" className="text-violet" />
        <span className="flex-1 text-body-sm font-semibold">{t('workboards.agent')}</span>
      </div>
      <p className="m-0 text-body-sm text-ink-dim">{t('workboards.agentBody')}</p>
      <ul className="m-0 flex list-none flex-col gap-1.5 p-0">
        {prompts.map((key) => (
          <li key={key}>
            <button
              type="button"
              onClick={onAsk}
              className="w-full rounded-sm border border-hairline bg-card px-3 py-2 text-start text-body-sm text-ink-dim transition-colors hover:border-forge hover:text-ink"
            >
              {t(`workboards.prompt.${key}`)}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  )
}
